module.exports = __webpack_public_path__ + "static/pak-teamphoto-reveal-ac60c1451bb4873e5e40ff35673d7d76.gif";